import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e17eb54&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2e17eb54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17eb54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e17eb54')) {
      api.createRecord('2e17eb54', component.options)
    } else {
      api.reload('2e17eb54', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e17eb54&scoped=true&", function () {
      api.rerender('2e17eb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/more-content/index.vue"
export default component.exports